import { SignatureRow } from 'components/tables/data/signature/types';
import P2Regular from 'components/typography/P2Regular';

/**
 * Column for revisions (shows first revision name and count of others).
 */
export default function RevisionsColumn({ data: { revisions } }: { data: SignatureRow }) {
  if (revisions.length === 0) {
    return null;
  }

  const firstName = revisions[0].revisionName;
  const count = revisions.length;

  if (count === 1) {
    return <P2Regular lineClamp={3}>{firstName}</P2Regular>;
  }

  return (
    <P2Regular lineClamp={3}>
      {firstName} (+{count - 1})
    </P2Regular>
  );
}
